// TODO: black-keys this config or endpoint fetch it?
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 50;
export const USERNAME_MIN_LENGTH = 2;
export const USERNAME_MAX_LENGTH = 50;
export const MIN_LEGAL_AGE = 16;
export const MAX_AGE = 99;
export const MIN_CODE_LENGTH = 6;
export const MAX_CODE_LENGTH = 6;
